"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setDeepLinkParams = exports.setComponentState = exports.setComponentPath = exports.saveUserDetails = exports.savePreferredLocale = exports.saveBillingSubmitErrorAttempt = exports.removeSavedUserDetails = exports.removeDeepLinkParams = exports.getSavedUserDetails = exports.getPreferredLocale = exports.getEmailLocalStorage = exports.getDeepLinkParams = exports.getComponentState = exports.getComponentPath = exports.getBillingSubmitErrorAttempt = exports.deleteComponentState = exports.DEEP_LINK_PARAM_TYPE = void 0;
exports.setEmailStorageExpiry = setEmailStorageExpiry;
var _lodash = require("lodash");
var _constants = require("../utils/constants");
const DEEP_LINK_PARAM_TYPE = {
  pmscParams: 'pmsc_qc_deep_link_params',
  ulxParams: 'ulx_qc_deep_link_params'
};
exports.DEEP_LINK_PARAM_TYPE = DEEP_LINK_PARAM_TYPE;
const saveUserDetails = accountDetails => {
  const userDetails = {
    companyName: accountDetails.companyName,
    contact: {
      phone: {
        countryCode: accountDetails.countryCode,
        number: accountDetails.phoneNumber
      }
    },
    companyLocation: accountDetails.companyLocation,
    propertyCount: accountDetails.propertyCount,
    companyRegistration: accountDetails.companyRegistration || null,
    billingCurrency: accountDetails.currency
  };
  localStorage.setItem('ipmobUserDetail', JSON.stringify(userDetails));
};
exports.saveUserDetails = saveUserDetails;
const getSavedUserDetails = () => localStorage.getItem('ipmobUserDetail');
exports.getSavedUserDetails = getSavedUserDetails;
const removeSavedUserDetails = () => localStorage.removeItem('ipmobUserDetail');
exports.removeSavedUserDetails = removeSavedUserDetails;
const getInitialComponentState = publicUuid => typeof localStorage === 'undefined' ? null : localStorage.getItem(`${publicUuid}.state`);
const setComponentState = (publicUuid, name, state) => {
  const loadingDateTime = new Date();
  const componentState = {
    name,
    loadingDateTime,
    state
  };
  const componentsStateInfo = getInitialComponentState(publicUuid) ? JSON.parse(getInitialComponentState(publicUuid)) : [];
  let stateExist = false;
  for (const component of componentsStateInfo) {
    if (component.name === name) {
      stateExist = true;
      component.loadingDateTime = loadingDateTime;
      component.state = state;
      break;
    }
  }
  if (!stateExist) {
    componentsStateInfo.push(componentState);
  }
  localStorage.setItem(`${publicUuid}.state`, JSON.stringify(componentsStateInfo));
};
exports.setComponentState = setComponentState;
const getComponentState = (publicUuid, name) => {
  let storedComponentInfo;
  if (typeof localStorage === 'undefined') {
    return null;
  }
  storedComponentInfo = localStorage.getItem(`${publicUuid}.state`);
  const parsedComponentInfo = !(0, _lodash.isEmpty)(storedComponentInfo) ? JSON.parse(storedComponentInfo) : [];
  const componentState = parsedComponentInfo.length > 0 ? parsedComponentInfo.find(element => element.name === name) : null;
  return componentState;
};
exports.getComponentState = getComponentState;
const deleteComponentState = publicUuid => {
  if (typeof localStorage !== 'undefined') {
    localStorage.removeItem(`${publicUuid}.state`);
  }
};
exports.deleteComponentState = deleteComponentState;
const setComponentPath = (publicUuid, path) => localStorage.setItem(`${publicUuid}.path`, path);
exports.setComponentPath = setComponentPath;
const getComponentPath = publicUuid => typeof localStorage === 'undefined' ? null : localStorage.getItem(`${publicUuid}.path`);
exports.getComponentPath = getComponentPath;
const setDeepLinkParams = (paramType, deepLinkParams) => localStorage.setItem(paramType, JSON.stringify(deepLinkParams));
exports.setDeepLinkParams = setDeepLinkParams;
const getDeepLinkParams = paramType => JSON.parse(localStorage.getItem(paramType));
exports.getDeepLinkParams = getDeepLinkParams;
const removeDeepLinkParams = paramType => localStorage.removeItem(paramType);
exports.removeDeepLinkParams = removeDeepLinkParams;
const getEmailLocalStorage = () => {
  const currentStorage = localStorage.getItem(_constants.EMAIL_LOCAL_STORAGE_KEY);
  return currentStorage ? JSON.parse(currentStorage) : {};
};
exports.getEmailLocalStorage = getEmailLocalStorage;
function setEmailStorageExpiry(helpFormData) {
  const storage = getEmailLocalStorage();
  const INELIGIBLE_SUBTYPE = helpFormData.data.message;
  const expiryDate = new Date();
  expiryDate.setDate(expiryDate.getDate() + 1); // TTL is 24 hours
  localStorage.setItem(_constants.EMAIL_LOCAL_STORAGE_KEY, JSON.stringify({
    ...storage,
    [INELIGIBLE_SUBTYPE]: expiryDate
  }));
}
const savePreferredLocale = (publicUuid, locale) => locale && typeof localStorage !== 'undefined' ? localStorage.setItem(`${publicUuid}.preferredLocale`, locale) : null;
exports.savePreferredLocale = savePreferredLocale;
const getPreferredLocale = publicUuid => typeof localStorage === 'undefined' ? null : localStorage.getItem(`${publicUuid}.preferredLocale`);
exports.getPreferredLocale = getPreferredLocale;
const getBillingSubmitErrorAttempt = () => typeof localStorage !== 'undefined' ? localStorage.getItem(_constants.BILLING_ERROR_LOCAL_STORAGE_KEY) : null;
exports.getBillingSubmitErrorAttempt = getBillingSubmitErrorAttempt;
const saveBillingSubmitErrorAttempt = () => {
  const currentStorage = getBillingSubmitErrorAttempt();
  const noOfAttempts = currentStorage ? parseInt(currentStorage, 10) + 1 : 1;
  localStorage.setItem(_constants.BILLING_ERROR_LOCAL_STORAGE_KEY, noOfAttempts);
};
exports.saveBillingSubmitErrorAttempt = saveBillingSubmitErrorAttempt;
//# sourceMappingURL=localStorageDataHandler.js.map